// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingNew_loadingContainer__lCzPD","animationContainer":"LoadingNew_animationContainer__pQmmI","animation":"LoadingNew_animation__GWVtD"};